/**
 * Formats a number with specified decimal places
 * @param {any} number - The number to format. Anything that is not a number will just be returned
 * @param {number} decimalPlaces - Number of decimal places to show (default: 2)
 * @param {boolean} forceDecimalPlaces - Whether to always show the specified number of decimal places (default: false)
 * @returns Formatted number as a string
 */
export function formatNumber(number: any, decimalPlaces: number = 2, forceDecimalPlaces: boolean = false) {
  if (typeof number !== 'number') {
    return number;
  }

  return number.toLocaleString(undefined, {
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: forceDecimalPlaces ? decimalPlaces : 0,
  });
}

/**
 * Formats a number as currency
 * @param {any} number - The number to format as currency. Anything that is not a number will just be returned
 * @param {string} currency - The currency to use (default: 'GBP')
 * @param {boolean} forceDecimalPlaces - Whether to always show the specified number of decimal places (default: false)
 * @param {number} decimalPlaces - Number of decimal places to show (default: 2)
 * @returns Formatted currency string
 */
export function formatCurrency(number: any, currency: string = 'GBP', forceDecimalPlaces: boolean = false, decimalPlaces: number = 2) {
  if (typeof number !== 'number') {
    return number;
  }

  return number.toLocaleString('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: forceDecimalPlaces ? decimalPlaces : 0,
  });
}
